<script type="text/ecmascript-6">
import ElDatePicker from 'element-ui/lib/date-picker'

export default {
  name: 'UniDatePicker',
  data() {
    return {
      // 默认快捷选项
      defaultPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }, {
          text: '一个月前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  mixins: [
    ElDatePicker
  ],
  mounted() {
    // 设置默认快捷选项
    this.pickerOptions = this.defaultPickerOptions
    // 由于mountPicker方法在ElDatePicker组件的created方法调用，因此只能重新加载组件
    this.unmountPicker()
    this.mountPicker()
  },
  methods: {
  }
}
</script>

<style lang="scss">
  // @import "UniDatePicker.scss";
</style>



// WEBPACK FOOTER //
// src/components/uniWidgets/UniDatePicker/UniDatePicker.vue